import { useEffect, useRef } from 'react';

import { useStore } from 'core/store';

/**
 * "<agency name> - <code>" for an affinity code, or the bare code until (or unless) its lookup row
 * loads. Refetches rows removed by affinity searches, but only tries a missing code once so a
 * typo'd or retired code returning 404 isn't refetched on every render.
 */
const useAffinityDisplayName = (affinityCode) => {
  const { affinityLookups } = useStore();
  const affinityRow = affinityCode ? affinityLookups.data.find(({ affinity }) => affinity === affinityCode) : null;
  const requestedAffinityRef = useRef(null);

  useEffect(() => {
    if (affinityRow) {
      requestedAffinityRef.current = null;
      return;
    }
    if (affinityCode && !affinityLookups.partialLoading && requestedAffinityRef.current !== affinityCode) {
      requestedAffinityRef.current = affinityCode;
      affinityLookups.getByAffinity(affinityCode);
    }
  }, [affinityCode, affinityRow, affinityLookups, affinityLookups.partialLoading]);

  if (!affinityCode) {
    return null;
  }
  return affinityRow?.name ? `${affinityRow.name} - ${affinityCode}` : affinityCode;
};

export default useAffinityDisplayName;
